// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file common/v1/shopper.proto (package common.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Address } from "./common_pb";
import { PostalAddress } from "../../google/type/postal_address_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";

/**
 * @generated from enum common.v1.JourneyType
 */
export const JourneyType = proto3.makeEnum(
  "common.v1.JourneyType",
  [
    {no: 0, name: "JOURNEY_TYPE_TRANSACTIONAL_UNSPECIFIED", localName: "TRANSACTIONAL_UNSPECIFIED"},
    {no: 1, name: "JOURNEY_TYPE_MERCHANT_MANAGED", localName: "MERCHANT_MANAGED"},
    {no: 2, name: "JOURNEY_TYPE_JPMC_MANAGED", localName: "JPMC_MANAGED"},
    {no: 3, name: "JOURNEY_TYPE_CHECKOUT_MANAGED", localName: "CHECKOUT_MANAGED"},
  ],
);

/**
 * @generated from enum common.v1.ProfileSource
 */
export const ProfileSource = proto3.makeEnum(
  "common.v1.ProfileSource",
  [
    {no: 0, name: "PROFILE_SOURCE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PROFILE_SOURCE_SETUP_CHECKOUT_INTENT", localName: "SETUP_CHECKOUT_INTENT"},
    {no: 2, name: "PROFILE_SOURCE_PBL_CREATION", localName: "PBL_CREATION"},
  ],
);

/**
 * SHOPPER ENTITY
 * Next id : 8
 *
 * @generated from message common.v1.Shopper
 */
export const Shopper = proto3.makeMessageType(
  "common.v1.Shopper",
  () => [
    { no: 4, name: "reference", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "profile_id", jsonName: "consumerProfileId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "billing_address", kind: "message", T: Address },
  ],
);

/**
 * @generated from message common.v1.ShopperProfile
 */
export const ShopperProfile = proto3.makeMessageType(
  "common.v1.ShopperProfile",
  () => [
    { no: 1, name: "profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "payment_gateway_profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "middle_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "journey", kind: "enum", T: proto3.getEnumType(JourneyType) },
    { no: 8, name: "shipping_addresses", kind: "message", T: ProfileAddress, repeated: true },
    { no: 9, name: "billing_addresses", kind: "message", T: ProfileAddress, repeated: true },
    { no: 11, name: "profile_source", kind: "enum", T: proto3.getEnumType(ProfileSource) },
  ],
);

/**
 * @generated from message common.v1.ProfileAddress
 */
export const ProfileAddress = proto3.makeMessageType(
  "common.v1.ProfileAddress",
  () => [
    { no: 1, name: "profile_address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "address", kind: "message", T: PostalAddress },
    { no: 3, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

